__turbopack_export_value__({
  "body-logo-18": "ShowMoreButton-module-scss-module__UZL2sa__body-logo-18",
  "body-text-12": "ShowMoreButton-module-scss-module__UZL2sa__body-text-12",
  "body-text-14": "ShowMoreButton-module-scss-module__UZL2sa__body-text-14",
  "body-text-16": "ShowMoreButton-module-scss-module__UZL2sa__body-text-16",
  "body-text-18": "ShowMoreButton-module-scss-module__UZL2sa__body-text-18",
  "body-text-20": "ShowMoreButton-module-scss-module__UZL2sa__body-text-20",
  "body-text-24": "ShowMoreButton-module-scss-module__UZL2sa__body-text-24",
  "body-text-24-2": "ShowMoreButton-module-scss-module__UZL2sa__body-text-24-2",
  "body-text-heading-2": "ShowMoreButton-module-scss-module__UZL2sa__body-text-heading-2",
  "body-text-heading-3": "ShowMoreButton-module-scss-module__UZL2sa__body-text-heading-3",
  "body-text-medium-14": "ShowMoreButton-module-scss-module__UZL2sa__body-text-medium-14",
  "body-text-medium-16": "ShowMoreButton-module-scss-module__UZL2sa__body-text-medium-16",
  "body-text-medium-18": "ShowMoreButton-module-scss-module__UZL2sa__body-text-medium-18",
  "body-text-medium2-18": "ShowMoreButton-module-scss-module__UZL2sa__body-text-medium2-18",
  "body-text2-14": "ShowMoreButton-module-scss-module__UZL2sa__body-text2-14",
  "body-text2-16": "ShowMoreButton-module-scss-module__UZL2sa__body-text2-16",
  "button": "ShowMoreButton-module-scss-module__UZL2sa__button",
  "button-primary-text": "ShowMoreButton-module-scss-module__UZL2sa__button-primary-text",
  "button-text": "ShowMoreButton-module-scss-module__UZL2sa__button-text",
  "button2-text": "ShowMoreButton-module-scss-module__UZL2sa__button2-text",
  "button__disabled": "ShowMoreButton-module-scss-module__UZL2sa__button__disabled",
  "card-shadow": "ShowMoreButton-module-scss-module__UZL2sa__card-shadow",
  "effect-menu": "ShowMoreButton-module-scss-module__UZL2sa__effect-menu",
  "header-1": "ShowMoreButton-module-scss-module__UZL2sa__header-1",
  "main-container": "ShowMoreButton-module-scss-module__UZL2sa__main-container",
  "main-footer-container": "ShowMoreButton-module-scss-module__UZL2sa__main-footer-container",
  "main-header-container": "ShowMoreButton-module-scss-module__UZL2sa__main-header-container",
  "txt-12-bold": "ShowMoreButton-module-scss-module__UZL2sa__txt-12-bold",
  "txt-14-bold": "ShowMoreButton-module-scss-module__UZL2sa__txt-14-bold",
  "txt-14-bold-caps": "ShowMoreButton-module-scss-module__UZL2sa__txt-14-bold-caps",
  "txt-14-med": "ShowMoreButton-module-scss-module__UZL2sa__txt-14-med",
  "txt-16-bold": "ShowMoreButton-module-scss-module__UZL2sa__txt-16-bold",
  "txt-16-med": "ShowMoreButton-module-scss-module__UZL2sa__txt-16-med",
  "txt-18-bold": "ShowMoreButton-module-scss-module__UZL2sa__txt-18-bold",
  "txt-18-medium": "ShowMoreButton-module-scss-module__UZL2sa__txt-18-medium",
  "txt-18-medium-24": "ShowMoreButton-module-scss-module__UZL2sa__txt-18-medium-24",
  "txt-24-semi": "ShowMoreButton-module-scss-module__UZL2sa__txt-24-semi",
});
